import { Col, Row } from "react-bootstrap";

import {
  BG_JOB_STATUS,
  defaultGridStateModalDataTable,
} from "../../../../constants";
import { DataTableComponent, ProgressBar } from "../../../../shared/components";
import CustomBodyModal from "../../../../shared/components/modal/CustomBodyModal";
import {
  calculateBarWidth,
  formatedDateTime,
  shopifyResetStatusDetailViewColumnHeaders,
} from "../../../../shared/utility";
import { useState } from "react";

const ResetStatusDetailViewModal = (props) => {
  const { selectedStatus, handleCloseDetailModal } = props;
  const failedProducts = selectedStatus?.failedProducts ?? [];
  const selectedStoreMiscData = selectedStatus?.miscData ?? {};
  const [gridState, setGridState] = useState(defaultGridStateModalDataTable);

  return (
    selectedStatus && (
      <CustomBodyModal
        title="Reset Shopify Details"
        show={!!selectedStatus}
        onHide={handleCloseDetailModal}
        size="lg"
      >
        <Row>
          <Col>
            <p className="my-1 fw-bold">Progress</p>
            <ProgressBar
              min={0}
              max={100}
              current={selectedStoreMiscData?.progressPercentage || 0}
              percentage={calculateBarWidth(
                100,
                selectedStoreMiscData?.progressPercentage || 0
              )}
              label={`${selectedStoreMiscData?.progressPercentage || 0}%`}
              barWrapper={true}
            />

            <div className="d-flex flex-column my-4 gap-2">
              <p>
                <span className="fw-bold">Status:</span>{" "}
                {selectedStoreMiscData?.status || "N/A"}
              </p>
              <p>
                <span className="fw-bold">Started at:</span>{" "}
                {selectedStoreMiscData?.startedAt
                  ? formatedDateTime(selectedStoreMiscData.startedAt)
                  : "N/A"}
              </p>

              {selectedStoreMiscData?.completedAt && (
                <p>
                  <span className="fw-bold">Completed at:</span>{" "}
                  {formatedDateTime(selectedStoreMiscData.completedAt)}
                </p>
              )}

              {selectedStoreMiscData?.scheduleTime &&
                selectedStoreMiscData?.status === BG_JOB_STATUS.PAUSED && (
                  <p>
                    <span className="fw-bold">Schedule Time:</span>{" "}
                    {formatedDateTime(selectedStoreMiscData.scheduleTime)}
                  </p>
                )}

              {selectedStoreMiscData?.lastResumedAt && (
                <p>
                  <span className="fw-bold">Last Resumed at:</span>{" "}
                  {formatedDateTime(selectedStoreMiscData.lastResumedAt)}
                </p>
              )}

              {selectedStoreMiscData?.lastPausedAt && (
                <p>
                  <span className="fw-bold">Last Paused at:</span>{" "}
                  {formatedDateTime(selectedStoreMiscData.lastPausedAt)}
                </p>
              )}

              {selectedStoreMiscData?.terminatedAt && (
                <p>
                  <span className="fw-bold">Terminated at:</span>{" "}
                  {formatedDateTime(selectedStoreMiscData.terminatedAt)}
                </p>
              )}

              <p>
                <span className="fw-bold">Total Inventory Count:</span>{" "}
                {selectedStoreMiscData?.totalInventoryCount ?? "N/A"}
              </p>
            </div>
          </Col>
        </Row>
        {failedProducts.length ? (
          <Row>
            <DataTableComponent
              resizableColumns={false}
              responsive={false}
              className="editable-table"
              columns={shopifyResetStatusDetailViewColumnHeaders()}
              data={failedProducts}
              total={failedProducts.length || 0}
              gridState={gridState}
              setGridState={setGridState}
            />
          </Row>
        ) : (
          <></>
        )}
      </CustomBodyModal>
    )
  );
};

export default ResetStatusDetailViewModal;
